import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { scrollToId, scrollToTop } from "../lib/booking";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Para Ella", id: "experiencia-ella" },
  { label: "Para Él", id: "experiencia-el" },
  { label: "DUO", id: "experiencias-duo" },
  { label: "Testimonios", id: "testimonios" },
];

const Navbar = () => {
  const [show, setShow] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleResizeOrScroll = () => {
      setShow(window.innerWidth < 768 || window.scrollY > window.innerHeight * 0.7);
    };
    handleResizeOrScroll();
    window.addEventListener("scroll", handleResizeOrScroll);
    window.addEventListener("resize", handleResizeOrScroll);
    return () => {
      window.removeEventListener("scroll", handleResizeOrScroll);
      window.removeEventListener("resize", handleResizeOrScroll);
    };
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.nav
          data-testid="navbar"
          initial={{ y: -80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -80, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 top-0 z-50 flex flex-col border-b border-[#3a3939]/10 bg-[#faf9f6]/95 backdrop-blur-xl"
        >
          <div className="flex items-center justify-between px-4 py-3 md:px-14 md:py-4 w-full">
            <button
              data-testid="nav-logo"
              onClick={scrollToTop}
              className="flex items-center"
            >
              <img
                src="/images/duo_experience_b.svg"
                alt="DUO Experience"
                className="h-7 md:h-8 w-auto object-contain"
              />
            </button>

            {/* Links for Desktop */}
            <div className="hidden items-center gap-7 md:flex">
              {links.map((l) => (
                <button
                  key={l.id}
                  data-testid={`nav-${l.id}`}
                  onClick={() => scrollToId(l.id)}
                  className="label text-[#6b615c] transition-colors hover:text-[#593d36]"
                >
                  {l.label}
                </button>
              ))}
            </div>

            {/* Actions: Reservar + Hamburger menu icon */}
            <div className="flex items-center gap-2">
              <button
                data-testid="nav-reserva"
                onClick={() => {
                  scrollToId("reserva");
                  setMobileMenuOpen(false);
                }}
                className="rounded-full bg-[#3a3939] px-3.5 py-1.5 md:px-5 md:py-2.5 text-white transition-all hover:bg-[#cea498] hover:text-[#593d36] font-bold"
              >
                <span className="label text-[10px] md:text-xs">Reservar</span>
              </button>
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="rounded-full p-1.5 text-[#3a3939] hover:bg-[#3a3939]/5 md:hidden"
              >
                {mobileMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
              </button>
            </div>
          </div>

          {/* Dropdown Menu for Mobile */}
          {mobileMenuOpen && (
            <div className="border-t border-[#3a3939]/5 bg-[#faf9f6] flex flex-col md:hidden px-4 py-3 gap-3 shadow-md">
              {links.map((l) => (
                <button
                  key={l.id}
                  onClick={() => {
                    scrollToId(l.id);
                    setMobileMenuOpen(false);
                  }}
                  className="text-left py-1 text-xs label text-[#6b615c] hover:text-[#593d36] transition-all"
                >
                  {l.label}
                </button>
              ))}
            </div>
          )}
        </motion.nav>
      )}
    </AnimatePresence>
  );
};

export default Navbar;
